import $ from 'jquery';
import 'bootstrap';
import Swiper from 'swiper';
import Sticky from 'sticky-js';
import SmoothScroll from 'smooth-scroll';


(function ($) {
    $(document).ready(function() {
    
        var projectsSlider = new Swiper ('.projects-slider', {
            loop: true,
            navigation: {
                nextEl: '.projects-slider__next',
                prevEl: '.projects-slider__prev',
            },
            on: {
                resize: function () {
                    this.update();
                }
            }
        });

        var coverImageSlider = new Swiper('.cover-image-slider', {
            loop: true,
            navigation: {
                nextEl: '.cover-image-slider__next',
                prevEl: '.cover-image-slider__prev',
            },
            pagination: {
                el: '.cover-image-slider__pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    return current + ' - ' + total;
                }
            },
            on: {
                resize: function () {
                    this.update();
                }
            }
        });

        var sticky = new Sticky('#paragraph-nav-container', {marginTop: 173});

        var scroll = new SmoothScroll('.paragraph__links .nav-link', {header: '.page__header', speedAsDuration: true});

        $(document).on('mouseenter', '.js-project-preview-source', function() {
            $('.js-project-preview-source').removeClass('-active');
            $(this).addClass('-active');
            $('.js-project-preview').attr('src', $(this).attr('data-image'));
        }).on('click', '.js-print', function(e) {
            e.preventDefault();
            window.print();
        }).on('click', '.js-back', function(e) {
            e.preventDefault();
            window.history.back();
        });

        var $source = $('.js-project-preview-source:eq(0)').addClass('-active');
        $('.js-project-preview').attr('src', $source.attr('data-image'));

        $(window).on('scroll', function() {
            $('.page__header:eq(0)').toggleClass('-scrolled', this.pageYOffset > 0);
        })
    });
})($);